<template>
  <div class="container-withdrawal" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px; background-color: #f9f9fb;`">
      <van-nav-bar class="van-bar" title="" left-selected-account @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Withdraw -->
          <span class="tit-left" v-if="walletType == 0">{{ $t('lang.BaseCommon.k096') }}</span>
          <!-- Withdrawal - Agent -->
          <span class="tit-left" v-if="walletType == 1">{{ $t('lang.Withdrawal.k027') }}</span>
        </template>
        <template #right>
          <span class="tit-right" @click="jumpPathWithQuery('/withdrawal-details', walletType)">{{ $t('lang.BaseCommon.k074') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="head">
        <div class="head-money">
          <div class="my-balance my">
            <div class="my-balance-tit">
              <span>{{ $t('lang.BaseCommon.k102') }}</span>
              <div class="my-balance-scale">
                <img :src="getMatchImg('beans')" alt="" />
                <span>{{ beansPerDollar }} ≈</span>
                <span>{{ currencyCode }}&nbsp;</span>
                <!-- 注意精度 -->
                <span>{{ handleNumberTransformK(currencyAmountPerDollar) }}</span>
              </div>
            </div>
            <div class="my-balance-beans">
              <div class="my-beans">
                <!-- prettier-ignore -->
                <span class="beans-img">
                  <img :src="getMatchImg('beans')" alt="" />{{ beans }}
                </span>
                <!-- 注意精度 -->
                <span class="beans-tran">≈{{ currencyCode }}&nbsp;{{ handleNumberTransformK(currencyAmount) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="amount">
          <span class="tit">{{ $t('lang.Withdrawal.k025') }}</span>
          <div class="amount-num">
            <div class="price-wrapper" v-for="(item, index) in moneyList" :key="index">
              <div
                class="price"
                :class="{
                  'price-active': Number(priceActive) == item,
                  'on-selece-price': minPrice && item < minPrice,
                }"
                @click="chooseAmount(item)"
              >
                <i v-if="item">
                  {{ item * 10 }}
                  <img :src="getMatchImg('beans')" alt="" width="16" />
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bind">
        <div class="method account" @click="jumpToBind(walletType, locaFlag, locaCode, withdrawAccounts, priceActive)">
          <div class="number">
            <img src="@/assets/packageAssets/views/P1_Girls/Withdrawal/default/dollar.webp" alt="" />
            <span>{{ $t('lang.BaseCommon.k106') }}</span>
          </div>
          <div class="selected-account">
            <div class="selected-account-box">
              <i v-if="!withdrawalMethod">{{ $t('lang.BaseCommon.k004') }}</i>
              <div v-else class="selected-account-info">
                <img :src="icon | imgPath" alt="" />
                <i>{{ withdrawalMethod }}</i>
              </div>
              <van-icon class="selected-account-icon" name="selected-account" />
            </div>
          </div>
        </div>
        <!-- 只有Pix和Paypal的时候才会不显示这个费率 -->
        <div class="fee-usdt" v-if="withdrawalMethod && !(withdrawalMethod == 'PIX')">
          {{ (feeUsdtMap[priceActive] || [])[0] || 'Fee 2%' }}
        </div>
      </div>
      <!-- 先验证是否此人被封禁 checkWithdrawInfo，再提现 showWithdrawConfirm -->
      <div :class="['withdraw-btn', priceActive && withdrawalMethod && priceActive * 10 <= beans ? 'withdraw-atc' : '']" @click="handleWithdrawClick">
        {{ $t('lang.BaseCommon.k096') }}
      </div>
      <div class="withdraw-rules">
        <span>{{ $t('lang.Withdrawal.k017') }}</span>
        <div>
          <span>1. {{ $t('lang.Withdrawal.k020') }}</span>
          <span>&nbsp;{{ minBeansPerDollar }}&nbsp;</span>
          <span>{{ $t('lang.Withdrawal.k018') }}</span>
        </div>
        <div>
          <span>2. {{ $t('lang.Withdrawal.k021') }}</span>
        </div>
        <div>
          <span>3. {{ $t('lang.Withdrawal.k022') }}</span>
          <span v-if="walletType == 0" class="learn-more" @click="jumpToInstantPayment">{{ $t('lang.Withdrawal.k019') }}</span>
        </div>
        <div>4. {{ $t('lang.Withdrawal.k023') }}</div>
        <div>5. {{ $t('lang.Withdrawal.k024') }}</div>
      </div>
    </div>

    <!-- 确认框 -->
    <van-dialog v-if="showDialog" v-model="showDialog" :showConfirmButton="false">
      <div class="dialog">
        <div class="title">{{ $t('lang.Withdrawal.k013') }}</div>
        <ul style="width: 100%">
          <!-- Amount -->
          <li class="amount-li">
            <span>{{ $t('lang.BaseCommon.k054') }}：</span>
            <!-- 注意精度 -->
            <template v-if="withdrawalMethod === 'USDT(TRC20)' || withdrawalMethod === 'USDT(TRC20/BEP20)' || withdrawalMethod === 'USDT(BINANCE)'">
              <i>≈USDT {{ returnFloat(myDiv(myTimes(priceActive, 10), beansPerDollar)) }}</i>
            </template>
            <template v-else>
              <i>
                ≈{{ currencyCode }}{{ returnFloat(myTimes(myDiv(myTimes(priceActive, 10), beansPerDollar), myDiv(currencyAmountPerDollar, 100))) }}
              </i>
            </template>
          </li>

          <!-- Method -->
          <li class="method-li">
            <span>{{ $t('lang.BaseCommon.k058') }}：</span>
            <img :src="icon | imgPath" alt="" />
            <i>{{ withdrawalMethod }}</i>
          </li>

          <!--
            Fee 和 Arrival Amount
            非PIX-提现类型
          -->
          <template v-if="withdrawalMethod && withdrawalMethod !== 'PIX'">
            <!-- Fee -->
            <li class="amount-li">
              <span>{{ $t('lang.BaseCommon.k057') }}：</span>
              <i>{{ feeUsdt == '0.000' ? currencyCode + handelFeeTax(feeTax, currencyAmountPerDollar) : +feeUsdt * 100 + '%' }}</i>
            </li>
            <!-- Arrival Amount -->
            <li class="amount-li">
              <span>{{ $t('lang.BaseCommon.k055') }}：</span>
              <!-- 注意精度 -->
              <template v-if="withdrawalMethod === 'USDT(TRC20)' || withdrawalMethod === 'USDT(TRC20/BEP20)' || withdrawalMethod === 'USDT(BINANCE)'">
                <i>≈USDT {{ returnFloat(myTimes(myDiv(myMinus(myTimes(priceActive, 10), feeTax), beansPerDollar), myMinus(1, feeUsdt))) }}</i>
              </template>
              <!-- prettier-ignore -->
              <template v-else>
                <i>
                  ≈{{ currencyCode }}{{ returnFloat(myTimes(myTimes(myDiv(myMinus(myTimes(priceActive, 10), feeTax), beansPerDollar), myDiv(currencyAmountPerDollar, 100)), myMinus(1, feeUsdt))) }}
                </i>
              </template>
            </li>
          </template>

          <!-- Account -->
          <li class="account-li account-box">
            <span v-if="withdrawalMethod == 'USDT(TRC20)' || withdrawalMethod == 'USDT(TRC20/BEP20)'" type="text">
              {{ $t('lang.BaseCommon.k099') }}:
            </span>
            <span v-else>{{ $t('lang.BaseCommon.k103') }}：</span>
            {{ withdrawAccount }}
          </li>

          <!--
            Address
            USDT(BINANCE)-提现类型
          -->
          <template v-if="withdrawalMethod === 'USDT(BINANCE)' && accountAddress">
            <li class="method-li">
              <span>{{ $t('lang.BaseCommon.k100') }}：</span>
              <div class="account-address-text">{{ accountAddress }}</div>
            </li>
          </template>
        </ul>
        <div class="btn">
          <span @click="handleThinK">{{ $t('lang.BaseCommon.k098') }}</span>
          <span @click="handleConfirm" class="confirm-btn">{{ $t('lang.BaseCommon.k028') }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- 升级版本确认框 -->
    <c-update :showDiaUp="showDiaUp" :title="titleConfirmUp"></c-update>

    <!-- 二次确认框 -->
    <van-dialog v-model="showDiaConfirm" :showConfirmButton="false" :closeOnClickOverlay="true" @close="cancelAgain">
      <div class="confirm-dialog-wrapper">
        <div class="headline" v-if="headline">{{ headline }}</div>
        <div class="title">{{ titleConfirm }}</div>
        <div class="btn">
          <div @click="jumpPathWithQuery('/withdrawal-details', walletType)" class="confirm-btn">
            {{ $t('lang.BaseCommon.k056') }}
          </div>
          <div @click="cancelAgain" class="confirm-think">{{ $t('lang.BaseCommon.k019') }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 提现报错之后也用弹框提示，因为客户端用的会把提示消息截断 显示不全 -->
    <confirm-dia :con="con" :showDia="showDia"></confirm-dia>

    <!-- 优质用户弹窗 -->
    <van-dialog v-model="popupVisible" title="" :showConfirmButton="false" :showCancelButton="false" width="300">
      <div class="dialog-wrapper">
        <div class="content">
          <p>
            <span>{{ $t('lang.Withdrawal.k026') }}</span>
            <img :src="getMatchImg('beans')" alt="coin" width="24" height="24" />
          </p>
        </div>
        <div class="fonter-wrapper">
          <div class="confirm-btn withdraw-atc" @click="handleWithdrawClick">
            {{ $t('lang.BaseCommon.k096') }}
          </div>
          <div @click="popupVisible = false">{{ $t('lang.BaseCommon.k019') }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 用户未实名弹窗 -->
    <van-dialog v-model="showNoAuthDia" title="" :showConfirmButton="false" :showCancelButton="false" width="300">
      <div class="dialog-wrapper">
        <div class="title">{{ $t('lang.BaseCommon.k069') }}</div>
        <div class="content">
          <p>
            <span>{{ $t('lang.BaseCommon.k014') }}</span>
          </p>
        </div>
        <div class="fonter-wrapper">
          <div class="confirm-btn withdraw-atc" @click="jumpToUserVerify">{{ $t('lang.BaseCommon.k015') }}</div>
          <div @click="showNoAuthDia = false">{{ $t('lang.BaseCommon.k019') }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 提现失败提示弹框 -->
    <van-dialog v-model="showNotApprovedDialog" :showConfirmButton="false">
      <div class="dialog not-approved-dialog">
        <div class="title">{{ $t('lang.Withdrawal.k001') }}</div>

        <div class="not-approved-content">
          <div class="info-item">
            <div class="item-title">{{ $t('lang.BaseCommon.k058') }}</div>
            <div class="item-value">{{ notApprovedInfo.withdrawMethod || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.BaseCommon.k054') }}</div>
            <div class="item-value purple">
              {{ notApprovedInfo.applyAmount ? `≈${notApprovedInfo.currency} ${handleUSDollar(notApprovedInfo.applyAmount)}` : '-' }}
            </div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.BaseCommon.k059') }}</div>
            <div class="item-value">{{ notApprovedInfo.createTime ? handleMoment(notApprovedInfo.createTime, 'DD/MM/YYYY HH:mm:ss') : '-' }}</div>
          </div>
        </div>

        <div class="btn">
          <span class="confirm-btn" @click="handleViewDetail">{{ $t('lang.BaseCommon.k056') }}</span>
          <span class="later-btn" @click="handleCommonSure('showNotApprovedDialog')">{{ $t('lang.BaseCommon.k019') }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- USDT(BINANCE) off 已绑定,未填写链地址 -->
    <van-dialog v-model="showUsdtBinanceOff1" :showConfirmButton="false">
      <div class="dialog not-approved-dialog">
        <div class="title">{{ $t('lang.Withdrawal.k002') }}</div>

        <p>{{ $t('lang.Withdrawal.k003') }}</p>

        <div class="btn">
          <span class="confirm-btn" @click="jumpToWithdrawAccount">{{ $t('lang.Withdrawal.k004') }}</span>
          <span class="later-btn" @click="handleCommonSure('showUsdtBinanceOff1')">{{ $t('lang.BaseCommon.k019') }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- USDT(BINANCE) off 已绑定,已填写链地址 -->
    <van-dialog v-model="showUsdtBinanceOff2" :showConfirmButton="false">
      <div class="dialog not-approved-dialog">
        <div class="title">{{ $t('lang.Withdrawal.k002') }}</div>

        <p>{{ $t('lang.Withdrawal.k005') }}</p>

        <div class="btn">
          <span class="confirm-btn" @click="handleCommonSure('showUsdtBinanceOff2')">{{ $t('lang.BaseCommon.k088') }}</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiWithdrawPage, apiFetchUserAccountInfo } from '@/api/imee'
import { pageCssVars } from './z-style-cfg.js'

import { formatMixin } from './mixins/format.mixin.js'
import { queryMixin } from './mixins/query.mixin.js'
import { dialogMixin } from './mixins/dialog.mixin.js'
import { applyMixin } from './mixins/apply.mixin.js'

import CUpdate from '@/components/CUpdate'
import ConfirmDia from '@/components/CConfirmDia'

export default {
  components: { CUpdate, ConfirmDia },
  mixins: [pageCssVars, formatMixin, queryMixin, dialogMixin, applyMixin],
  data() {
    const localData = JSON.parse(sessionStorage.getItem('bind-withdrawal') || '{}')
    const query = this.$route.query
    return {
      // 页面布局
      topBarHeight: query.statusBarHeight || 38,

      // 用户地区
      locaFlag: '',
      locaCode: '',

      // 钱包类型（0 主播 / 1 代理）
      walletType: localData.walletType || query.walletType || 0,

      // 余额与币种展示
      beans: 0,
      beansPerDollar: 1000,
      minBeansPerDollar: 10000,
      currencyAmount: null,
      currencyAmountPerDollar: null,
      currencyCode: null,

      // 提现金额档位
      moneyList: [],
      priceActive: localData.price || query.price || '',
      minPrice: localData.minPrice || query.minPrice || null,

      // 提现账号与方式
      cfgId: localData.withdrawalMethod || query.withdrawalMethod || null,
      withdrawAccount: null,
      withdrawAccounts: null,
      withdrawalMethod: localData.withdrawalMethod || query.withdrawalMethod || null,
      icon: localData.icon || query.icon || null,
      accountAddress: '',

      // 缓存
      cacheWithdrawMethods: null,

      // 费率
      feeUsdt: 0,
      feeUsdtMap: [],
      feeTax: 0,
    }
  },
  methods: {
    // 返回上一页，根据来源页跳转不同路由
    handleBack() {
      const query = this.$route.query
      if (query.fromPage && query.fromPage == 'invite') {
        this.goPrevious()
        return
      }

      this.closeWeb()
    },

    // 获取提现页初始数据（余额、档位、费率、通知弹窗等）
    fetchBaseInfo(afterFn) {
      apiWithdrawPage(this.walletType, this.withdrawalMethod || '').then((res) => {
        if (res && !res.error) {
          try {
            this.beansPerDollar = res.beansPerDollar || 1000
            this.moneyList = res && res.listWithdrawDollarsAmounts
            this.minBeansPerDollar = ((this.moneyList || [])[0] || 1000) * 10
            if (res.listWithdrawDollarsAmounts && res.listWithdrawDollarsAmounts.length > 0) {
              const queryPrice = this.priceActive || ''
              if ((res.listWithdrawDollarsAmounts || []).findIndex((v) => v === queryPrice) > -1) {
                this.priceActive = queryPrice
              } else {
                this.priceActive = res.listWithdrawDollarsAmounts[0]
              }
            }
            this.currencyAmount = res.currencyAmount
            this.currencyAmountPerDollar = res.currencyAmountPerDollar
            this.currencyCode = res.currencyCode

            this.beans = res.beansAmount
            this.withdrawAccounts = res.withdrawAccounts
            this.cacheWithdrawMethods = res.withdrawMethods
            this.setWithdrawAccount(res.withdrawAccounts)

            let tempList = []
            if (this.withdrawalMethod) {
              if (!(this.withdrawalMethod == 'PIX')) {
                res.withdrawMethods.forEach((item) => {
                  if (item.withdrawalMethod == this.withdrawalMethod) {
                    tempList = item.withdrawDollarsList
                  }
                })
                tempList.forEach((item) => {
                  this.feeUsdtMap[item.dollarAmount] = [item.feeDesc, item.feeRate, item.feeTax]
                })
                const arr = this.feeUsdtMap[this.moneyList[0]] || []
                this.feeUsdt = ((this.feeUsdtMap || [])[this.priceActive] || [])[1] || arr[1] || 0
                this.feeTax = ((this.feeUsdtMap || [])[this.priceActive] || [])[2] || arr[2] || 0
              }
            }
            if (res.canWithdraw5Dollar) {
              this.popupVisible = true
            }

            if (res.notifies && res.notifies.length) {
              res.notifies.forEach((notifyItem) => {
                this.dialogStack.push({
                  ...notifyItem,
                })
              })
            }

            this.flushDialogStack()

            afterFn && afterFn()
          } catch (err) {
            console.log('try catch', err)
          }
        }
      })
    },

    // 获取用户地区信息（国家码、国旗）
    fetchUserAccountInfo() {
      apiFetchUserAccountInfo().then((res) => {
        this.locaCode = res.locationCode
        this.locaFlag = res.locationFlag
      })
    },

    // 选择提现金额档位
    chooseAmount(val) {
      if (!this.withdrawAccount) {
        this.$client.showToast(this.$t('lang.Withdrawal.k012'))
        return
      }
      this.priceActive = val
      this.feeUsdt = +((this.feeUsdtMap || [])[val] || [])[1]
    },

    // 跳转到绑定/选择提现账号页
    jumpToBind(walletType, locaFlag, locaCode, withdrawAccounts, price) {
      const boundMethods = (withdrawAccounts || []).map((item) => item.withdrawalMethod).filter(Boolean)

      this.$router.push({
        path: '/bind-withdrawal',
        query: {
          walletType,
          locaFlag,
          locaCode,
          accounts: JSON.stringify(boundMethods),
          price,
        },
      })
    },

    // 设置当前选中的提现账号（无选中时默认取第一个）
    setWithdrawAccount(res) {
      if (!res || !res.length) return

      if (!this.withdrawalMethod && !this.icon) {
        for (let i = 0; i < res.length; i++) {
          if (this.applyWithdrawAccount(res[i])) return
        }
        return
      }

      const target = res.find((item) => item.withdrawalMethod == this.withdrawalMethod)
      this.applyWithdrawAccount(target)
    },

    // 校验并应用提现账号（PIX 资料未完善时不设置）
    applyWithdrawAccount(item) {
      if (!item) return false
      if (item.withdrawalMethod === 'PIX' && item.profileCompleted === false) return false

      this.cfgId = item.cfgId
      this.withdrawAccount = item.accountId
      this.withdrawalMethod = item.withdrawalMethod
      this.icon = item.withdrawalMethodIcon
      this.minPrice = item.minDollarAmount
      this.accountAddress = item.accountAddress || ''
      return true
    },

    // 点击提现按钮，校验账号和金额后发起提现前置校验
    handleWithdrawClick() {
      this.popupVisible = false
      if (!this.withdrawAccount || !this.priceActive) {
        return this.$client.showToast(this.$t('lang.Withdrawal.k012'))
      }
      if (this.priceActive && this.withdrawalMethod && this.priceActive * 10 <= this.beans) {
        this.checkWithdrawInfo()
      }
    },

    // 校验余额后打开提现确认弹窗
    showWithdrawConfirm() {
      if (this.priceActive * 10 > this.beans) {
        this.$client.showToast(this.$t('lang.Withdrawal.k016'))
        return
      }
      this.showDialog = true
    },

    // 带 walletType 参数跳转指定页面
    jumpPathWithQuery(path, walletType) {
      this.$router.push({
        path,
        query: {
          walletType,
        },
      })
    },

    // 跳转到快速提现说明页
    jumpToInstantPayment() {
      this.$router.push({ path: 'instant-payment', query: {} })
    },
  },
  created() {
    this.replaceCurrentRoutePath(JSON.parse(sessionStorage.getItem('bind-withdrawal') || '{}'))
    sessionStorage.removeItem('bind-withdrawal')

    this.fetchBaseInfo()
    this.fetchUserAccountInfo()
    this.setWithdrawAccount()
  },
}
</script>

<style lang="scss" scoped>
.container-withdrawal {
  width: 100%;
  min-height: 100vh;
  background: var(--wd-page-bg);

  /* 主内容 */
  .main {
    margin-top: 20px;
    padding: 0 14px;
    .head {
      width: 100%;
      .head-money {
        width: 100%;
        padding: 16px 24px;
        position: relative;
        z-index: 100;
        margin: 0 auto;
        border-radius: 12px 12px 0 0;
        background: var(--wd-balance-gradient);
        .my-balance {
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-400);
          line-height: var(--lh-body-20);
          color: #ffffff;
          .my-balance-tit {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .my-balance-scale {
            display: flex;
            align-items: center;
            color: #ffd000;
            > img {
              width: 14px;
              height: 14px;
              margin: 0 2px;
            }
          }
          .my-balance-beans {
            display: flex;
            flex-wrap: wrap;
            width: 100%;

            font-weight: var(--fw-500);
            margin-top: 8px;
            font-family: var(--string-font);
            .my-beans {
              width: 100%;
              font-size: var(--fs-32);
              line-height: var(--lh-display-40);
              word-wrap: break-word;
              .beans-img {
                display: inline-block;
                > img {
                  width: 26px;
                  height: 26px;
                  vertical-align: middle;
                  margin: 0 1px;
                }
              }
              .beans-tran {
                display: inline-block;
                padding-bottom: 2px;
                font-family: var(--number-font);
                font-size: var(--fs-20);
                font-weight: var(--fw-400);
                line-height: var(--lh-title-28);
                color: #ffffff;
              }
            }
          }
        }
      }
      .amount {
        position: relative;
        z-index: 50;
        width: 100%;
        min-height: 173px;
        margin: 0 auto;
        background: #ffffff;
        border-radius: 0 0 12px 12px;
        padding: 20px 20px 25px;
        .tit {
          display: block;
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-500);
          line-height: var(--lh-body-24);
          color: #333333;
        }
        .amount-num {
          width: 100%;
          padding-top: 20px;
          overflow: hidden;
        }
        .price-wrapper {
          float: left;
          width: calc((100% - 24px) / 3);
          height: 40px;
          margin-top: 16px;
          margin-left: 12px;
          .price {
            i {
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 14px;
                margin: 0 2px;
              }
            }
          }
          &:nth-child(1) {
            margin-top: 0;
          }
          &:nth-child(2) {
            margin-top: 0;
          }
          &:nth-child(3) {
            margin-top: 0;
          }
          &:nth-child(3n + 1) {
            margin-left: 0;
          }
        }
        .price {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          background: #f9f9fb;
          border-radius: 4px;
          text-align: center;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-500);
          line-height: var(--lh-body-20);
          color: #666666;
          border: 1px solid #f9f9fb;
        }
        .price-active {
          background: var(--wd-price-active-bg);
          border: 1px solid var(--wd-price-active-border);
          color: var(--wd-price-active-color);
        }
        .on-selece-price {
          filter: grayscale(100%);
          pointer-events: none;
          background-color: #f1f3f4;
          color: #fff;
        }
      }
    }
    .bind {
      position: relative;
      width: 100%;
      margin: 20px auto 0;
      background: #ffffff;
      border-radius: 12px;
      padding: 0 17px;
      .phone {
        border-bottom: 0.5px solid #f4f4f4;
      }
      .account {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 18px 0;
        > .number {
          display: flex;
          align-items: center;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-500);
          line-height: var(--lh-body-20);
          color: #333333;
          > img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }
        > .selected-account {
          display: flex;
          align-items: center;
          font-family: var(--string-font);
          font-size: var(--fs-12);
          font-weight: var(--fw-400);
          line-height: var(--lh-label-16);
          color: #999999;
          .selected-account-icon {
            font-family: var(--string-font);
            font-size: var(--fs-14);
            font-weight: var(--fw-400);
            line-height: var(--lh-body-20);
            padding-left: 5px;
          }
        }
        .selected-account-box {
          display: flex;
          align-items: center;
        }
        .selected-account-info {
          display: flex;
          align-items: center;
          > img {
            height: 20px;
          }
        }
      }

      .fee-usdt {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 5px;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--wd-fee-badge-bg);
        border-radius: 0 8px 0 8px;
        font-family: var(--string-font);
        font-size: var(--fs-12);
        font-weight: var(--fw-400);
        color: #ffffff;
      }
    }

    .withdraw-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 289px;
      height: 40px;
      margin: 40px auto;
      background: #e1e1e1;
      border-radius: 20px;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-500);
      color: #ffffff;

      &.withdraw-atc {
        background: var(--wd-theme-color);
        color: var(--wd-theme-btn-color);
        pointer-events: auto;
      }
    }

    .withdraw-rules {
      font-family: var(--string-font);
      font-size: var(--fs-12);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-18);
      color: #999999;
      padding-bottom: 16px;
      > span {
        display: block;
        margin-bottom: 10px;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        font-weight: var(--fw-600);
        line-height: var(--lh-body-20);
        color: #666666;
      }
      > div {
        margin-bottom: 8px;
      }

      .learn-more {
        color: var(--wd-learn-more-color) !important;
        cursor: pointer;
      }
    }
  }

  /* 确认弹窗 */
  .dialog {
    width: 300px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 20px;
    margin: 0 auto;

    .title {
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-500);
      color: #333333;
      line-height: var(--lh-body-24);
      text-align: center;
      margin-bottom: 20px;
    }
    ul {
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-20);
      color: #666666;
      li {
        display: block;
        margin-bottom: 10px;
        > span {
          color: #333333;
        }
      }
      .amount-li {
        > i {
          color: var(--wd-dialog-amount-color);
          font-family: var(--string-font);
          font-weight: var(--fw-500);
        }
      }
      .method-li {
        display: flex;
        align-items: center;
        font-family: var(--string-font);
        > span {
          display: block;
        }
        > img {
          display: block;
          height: 20px;
        }
        > i {
          display: block;
          font-weight: var(--fw-500) !important;
          color: #000 !important;
          font-family: var(--string-font);
        }

        .account-address-text {
          width: 160px !important;
          white-space: normal !important;
          font-family: var(--string-font);
          font-weight: var(--fw-500);
          color: #000000;
          font-size: var(--fs-12) !important;
          line-height: var(--lh-label-16) !important;
          overflow-wrap: break-word !important;
        }
      }
      .account-li {
        font-family: var(--string-font);
        > span:nth-child(2) {
          font-weight: var(--fw-500) !important;
          color: #000 !important;
          font-family: var(--string-font);
        }
      }
      .account-box {
        font-family: var(--string-font);
        font-weight: var(--fw-500) !important;
        color: #000;
        word-wrap: break-word;
        > span {
          font-weight: var(--fw-400);
          color: #333;
        }
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      > span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 40px;
        background: #e1e1e1;
        border-radius: 20px;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-600);
        color: #ffffff;
      }
      .confirm-btn {
        background: var(--wd-theme-color);
        color: var(--wd-theme-btn-color);
        margin-left: 10px;
      }
    }

    &.not-approved-dialog {
      padding: 20px 6px;

      .not-approved-content {
        padding-top: 4px;

        .info-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          width: 100%;
          height: min-content;
          padding-bottom: 24px;
          &:last-child {
            padding-bottom: 0;
          }
          .item-title {
            width: fit-content;
            flex-grow: 0;
            font-family: var(--string-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-400);
            color: #999999;
            line-height: var(--lh-body-24);
            text-align: left;
            font-style: normal;
            padding-right: 10px;
          }
          .item-value {
            flex-grow: 1;
            font-family: var(--string-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-400);
            color: #333333;
            line-height: var(--lh-body-24);
            text-align: right;
            font-style: normal;
            word-break: break-word;
          }
          .purple {
            color: var(--wd-theme-color) !important;
          }
        }
      }

      .btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .later-btn,
        .confirm-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 283px;
          height: 48px;
          border-radius: 24px;
          margin: 0 auto;
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          margin-left: 0;
        }
        .later-btn {
          border: 1px solid var(--wd-theme-color);
          color: var(--wd-theme-color);
          background-color: transparent;
          margin-top: 16px;
        }
      }
    }
  }

  /* 轻提示类弹窗 */
  .dialog-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 300px;
    height: 200px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    font-weight: normal;
    padding: 20px;
    .title {
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-500);
      color: #333333;
      line-height: var(--lh-body-24);
      text-align: center;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100px;
      color: #000;
      img {
        vertical-align: bottom;
      }
    }
    .fonter-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 40px;
        border-radius: 20px;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        color: var(--wd-theme-color);
        font-weight: var(--fw-600);
        border: 1px solid var(--wd-theme-color);
      }
      .confirm-btn {
        background-color: #cccccc;
        margin-right: 10px;
        pointer-events: none;
        border-color: #cccccc !important;
        color: #ffffff !important;
      }
      .withdraw-atc {
        background-color: var(--wd-theme-color) !important;
        pointer-events: auto;
        color: #ffffff !important;
      }
    }
  }

  /* 二次确认弹窗 */
  .confirm-dialog-wrapper {
    width: 315px;
    max-width: 100%;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 20px 20px 20px;
    margin: 0 auto;
    .headline {
      width: 100%;
      text-align: center;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-600);
      color: #333333;
      line-height: var(--lh-body-24);
    }
    .title {
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      color: #333333;
      line-height: var(--lh-body-24);
      text-align: start;
      margin: 10px 0;
    }
    .btn {
      width: 100%;
      height: fit-content;
      padding-top: 10px;
      .confirm-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 48px;
        background-color: var(--wd-theme-color);
        border-radius: 24px;
        overflow: hidden;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        color: var(--wd-theme-btn-color);
        margin-bottom: 16px;
        cursor: pointer;
      }
      .confirm-think {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 48px;
        background-color: #ffffff;
        border: 1px solid var(--wd-theme-color);
        border-radius: 24px;
        overflow: hidden;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        color: var(--wd-theme-color);
        cursor: pointer;
      }
    }
  }
}

/* RTL 与导航（与模板树一致） */
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-withdrawal {
    .main .bind .fee-usdt {
      position: absolute;
      right: auto !important;
      left: 0 !important;
      border-radius: 8px 0 8px 0 !important;
    }

    .custom-nav-block .van-bar {
      .van-nav-bar__content {
        .van-nav-bar__right {
          .tit-right {
            padding-left: 0;
            padding-right: 30px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* 穿透 Vant NavBar，与 .custom-nav-block 树一致 */
.container-withdrawal {
  .custom-nav-block {
    .van-bar {
      .van-nav-bar__content {
        .van-nav-bar__right {
          padding: 0 !important;

          .tit-right {
            display: inline-flex;
            align-items: center;
            height: 100%;
            padding: 0 16px;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>
